import { memo, useEffect, useMemo, useState } from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { CSVLink as CSVLinkBase } from 'react-csv';
import { AlarmData } from 'src/features/alarms';
import { GraphSeriesType } from '../../types/readings';
import { formatTagDataForExport } from '../../utils/formatTagDataForExport';
import { tooltipItemBox, tooltipItemText, removeBox, StyledMenuPopover } from './style';
import { CloseIcon } from 'src/assets/icons/CloseIcon';
import { ExportIcon } from 'src/assets/icons/ExportIcon';

type Props = {
  htmlElement: any;
  onClosePopover: () => void;
  onRemoveHandler: () => void;
  pointChartData?: GraphSeriesType[];
  alarms?: AlarmData[];
  handleDownloadPNGClick: () => void;
  onSelectDataHandler: () => void;
};

const MenuPopoverOptionsComponent = ({
  htmlElement,
  onClosePopover,
  pointChartData,
  handleDownloadPNGClick,
  onRemoveHandler,
}: Props) => {
  const open = Boolean(htmlElement);

  const [exportPrimed, setExportPrimed] = useState(false);
  useEffect(() => {
    if (open) setExportPrimed(true);
  }, [open]);

  const tagForExport = useMemo(
    () => (exportPrimed && pointChartData ? formatTagDataForExport(pointChartData) : []),
    [exportPrimed, pointChartData]
  );

  const theme = useTheme();

  return (
    <StyledMenuPopover open={htmlElement} onClose={onClosePopover} arrow="right-top" theme={theme}>
      <Box sx={{ padding: '0.3rem 1rem' }}>
        <CSVLinkBase
          data-sm="download-csv"
          onClick={onClosePopover}
          style={{ textDecoration: 'none', color: 'inherit' }}
          data={tagForExport || []}
        >
          <Box sx={tooltipItemBox}>
            <ExportIcon width={10} height={10} />
            <Typography sx={tooltipItemText}>Download CSV</Typography>
          </Box>
        </CSVLinkBase>

        <Box sx={tooltipItemBox} onClick={handleDownloadPNGClick} data-sm="download-png">
          <ExportIcon width={10} height={10} />
          <Typography sx={tooltipItemText}>Download PNG</Typography>
        </Box>
        <Box sx={removeBox} onClick={onRemoveHandler} data-sm="remove-button">
          <CloseIcon width={10} />
          <Typography sx={tooltipItemText}>Remove</Typography>
        </Box>
      </Box>
    </StyledMenuPopover>
  );
};

export const MenuPopoverOptions = memo(MenuPopoverOptionsComponent);
